export default __webpack_public_path__ + "images/7_habitat.jpg";